import {Component, Input} from '@angular/core';
import {FilterParams} from "app/models/filter_form.model";
import {StatsRefs} from "app/views/referers/ref.model";
import {HelperService} from "app/lib/helper.service";
import {RefComponent} from "app/views/referers/ref.component";
import { AuthService } from "../../../auth.service";

@Component({
	selector: 'reg-day-refs',
	templateUrl: './ref.component.html',
})
export class RegDayRefComponent {
	@Input() public refs: StatsRefs;
	@Input() public filterParams: FilterParams;
	@Input() public currentUrl: string;

	Math: any;

	constructor(
		public helper: HelperService,
		public refComponent: RefComponent,
		public authService: AuthService,
	) {
		this.Math = Math;
	}

	async ngOnInit() {
		if (this.authService.isAllowResource('billing')) {
			this.filterParams.isBillingAllow = true;
		}
	}
}
